/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, October 25th 2021, 4:48:22 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  Responsive2ColGridContainer as GridContainer,
  Responsive2ColGridItem as GridItem,
  PaddedDivider,
} from "ui-widgets";
import {
  TextFormInput,
  TextAreaFormInput,
  CheckBoxFormInput,
  DropDownFormInput,
  RelatedObjectOSAPIFormProps,
  OSAPIForm,
} from "ui-widgets/forms";
import { DesignLayout, LAYOUT_OPTIONS } from "lib/schemas";
import { useTranslatedText } from "core";
import { PrimaryKeyValue } from "lib/types";
import { useDesignLayoutAPI } from "service-builder/services/DesignLayoutAPI";

interface DesignLayoutFormProps extends RelatedObjectOSAPIFormProps<DesignLayout> {
  designLayoutID?: PrimaryKeyValue<DesignLayout>;
  newDesignLayoutDefault: DesignLayout;
}

export const DesignLayoutForm = (props: DesignLayoutFormProps) => {
  const LANG = useTranslatedText();

  const { useDesignLayoutAPIForm } = useDesignLayoutAPI();

  const { useDesignLayoutAPIFormReturn } = useDesignLayoutAPIForm(
    props.designLayoutID,
    props.onSuccessfulAPISave,
    props.newDesignLayoutDefault
  );

  return (
    <OSAPIForm
      useAPIFormReturn={useDesignLayoutAPIFormReturn}
      onFormCancel={props.onFormCancel}
      loaderType="form-skeleton"
    >
      <GridContainer>
        <GridItem>
          <TextFormInput<DesignLayout> label={LANG.title} schema_field_key="title" />
          <CheckBoxFormInput<DesignLayout> schema_field_key="active" label={LANG.active} defaultChecked />
        </GridItem>
        <GridItem>
          <DropDownFormInput<DesignLayout>
            schema_field_key="layout_type"
            label={LANG.layoutType}
            options={LAYOUT_OPTIONS}
          />
        </GridItem>
      </GridContainer>
      <PaddedDivider />
      <TextAreaFormInput<DesignLayout> label={LANG.htmlDesign} schema_field_key="html_design" />
      <TextAreaFormInput<DesignLayout> label={LANG.internalCSS} schema_field_key="css" />
    </OSAPIForm>
  );
};
